<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import ExcelExport from "@/components/ExcelExport.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Customers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    ExcelExport,
  },
  data() {
    return {
      title: "Customers ",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Customers",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      existingCustomer: [],
      nameError: "",
      contactError: "",

      // Value from user input for adding unit
      data: {
        name: "",
        contact: "",
        category_id: "",
        tindata: {
          tin: "",
        },
        efris_status: 0,
      },
      // edit unit
      editdata: {
        name: "",
        contact: "",
        id: "",
        tindata: {
          tin: "",
        },
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
      },
      // merge data
      mergedata: {
        name: "",
        customer: "",
        id: "",
      },
      filterCustomers: {
        search: "",
        page: 1,
        per_page: 50,
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("customers", [
      "SaveStatus",
      "Customers",
      "CustomerDetails",
      "tinError",
      "CustomersPaginated",
      "CustomersPagination",
      "IsCustomersServerPaginated",
      "CustomersFilterStatus",
    ]),
    ...mapGetters("retailoutlets", ["RetailOutlets"]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("setting", ["BusinessSettings", "GeneralSettings"]),

    fields() {
      let base = [
        { key: "index", label: "S/N" },
        { key: "name", label: "NAME" },
        { key: "phone", label: "CONTACT" },
        { key: "tin", label: "TIN" },
        { key: "efris", label: "EFRIS STATUS" },
        { key: "user", label: "ADDED By" },
        { key: "addedon", label: "DATE ADDED" },
         {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ];

     if (this.GeneralSettings && this.GeneralSettings.use_customer_prices) {
        base.splice(4, 0, {
          key: "pricing_category",
          sortable: true,
          label: "PRICING CATEGORY",
        });
      }
      if (this.GeneralSettings && this.GeneralSettings.enable_debt_limit) {
        base.splice(4, 0, {
          key: "debt_limit",
          sortable: true,
          label: "DEBT LIMIT",
        });
      }

      return base;
    },

    rows() {
      return this.IsCustomersServerPaginated
        ? this.CustomersPagination.total
        : this.CustomersPaginated
        ? this.CustomersPaginated.length
        : 0;
    },
    currentPage: {
      get() {
        return this.IsCustomersServerPaginated
          ? this.CustomersPagination.current_page
          : this.clientCurrentPage;
      },
      set(value) {
        if (this.IsCustomersServerPaginated) {
          this.handlePageChange(value);
        } else {
          this.clientCurrentPage = value;
        }
      },
    },
    perPage: {
      get() {
        return this.IsCustomersServerPaginated
          ? this.CustomersPagination.per_page
          : this.clientPerPage;
      },
      set(value) {
        if (this.IsCustomersServerPaginated) {
          this.handlePerPageChange(value);
        } else {
          this.clientPerPage = value;
        }
      },
    },
    exportPayload() {
      return {
        customers: this.CustomersPaginated || [],
      };
    },
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    CustomerDetails(newVale) {
      if (newVale) {
        if (this.CustomerDetails) {
          (this.data.efris_status = 1),
            (this.data.name = this.CustomerDetails.legalName);
          this.data.contact = this.CustomerDetails.contactNumber;
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchCustomersData: "customers/fetchCustomersData",
      FetchCustomers: "customers/fetchCustomers",
      AddCustomer: "customers/addCustomer",
      EditCustomer: "customers/editCustomer",
      DeleteCustomer: "customers/deleteCustomer",
      TinSubmit: "customers/fetchCustomerDetails",
      FetchRetailOutlets: "retailoutlets/fetchRetailOutlets",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addCustomer(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Name  field is required";
        return;
      } else {
        this.nameError = "";
      }
      this.validateCustomer();
      if (this.contactError != "") {
        return;
      }

      this.AddCustomer(this.data);
      if (!this.SaveStatus) {
        this.resetAdd();
      }
    },

    validateCustomer() {
      if (this.data.name != "" && this.data.contact != "") {
        let selCust = this.Customers.filter((item) => {
          return item.phone == parseInt(this.data.contact);
        });
        let custCount = selCust.length;
        if (custCount > 0) {
          this.contactError =
            "Customer with contact " + this.data.contact + "  already Exists";
        }
      }
    },
    resetAdd() {
      this.data.name = "";
      this.data.contact = "";
      this.data.tindata.tin = "";
      this.modal_id = "";
    },
    resetEdit() {
      this.data.name = "";
      this.data.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
      this.contactError = "";
      this.tinError ? (this.tinError = "") : "";
    },
    showEditModal(val) {
      this.editdata.name = val.item.name;
      this.editdata.contact = val.item.phone;
      this.editdata.tindata.tin = val.item.tin;
      this.editdata.id = val.item.id;
    },
    editCustomer(modalId) {
      this.modal_id = modalId;
      this.validateCustomerEdit();
      if (this.contactError != "") {
        return;
      }
      this.EditCustomer(this.editdata);
    },
    validateCustomerEdit() {
      if (this.editdata.name != "" && this.editdata.contact != "") {
        let selCust = this.Customers.filter((item) => {
          return (
            item.phone == parseInt(this.editdata.contact) &&
            item.id != this.editdata.id
          );
        });
        let custCount = selCust.length;
        if (custCount > 0) {
          this.contactError =
            "Customer with contact " +
            this.editdata.contact +
            "  already Exists";
        }
      }
    },
    showDeleteModal(val) {
      this.deletedata.name = val.item.name;
      this.deletedata.id = val.item.id;
    },
    deleteCustomer(modalId) {
      this.modal_id = modalId;
      this.DeleteCustomer(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
      this.resetError();
      this.resetEdit();
      this.resetAdd();
      this.resetDelete();
    },

    submitTin() {
      if (this.data.tindata.tin == "") {
        this.tinError = "Tin field is required";
        return;
      } else {
        this.tinError = "";
        (this.data.efris_status = 0), this.TinSubmit(this.data.tindata);
      }
    },

    redirect(value) {
      this.$router.push(`/customer/customer_profile/${btoa(value)}`);
    },

    showMergeModal(data) {
      this.mergedata.name = data.item.name;
      this.mergedata.id = data.item.id;
    },

    mergeCustomer(modalId) {
      this.modal_id = modalId;
      this.MergeCustomer(this.mergedata);
    },

    resetMerge() {
      this.mergedata.name = "";
      this.mergedata.id = "";
      this.modal_id = "";
    },
    handlePageChange(newPage) {
      if (this.IsCustomersServerPaginated) {
        const payload = {
          ...this.filterCustomers,
          page: newPage,
        };
        this.filterCustomers.page = newPage;
        this.FetchCustomersData(payload);
      }
    },

    handlePerPageChange(newPerPage) {
      if (this.IsCustomersServerPaginated) {
        const payload = {
          ...this.filterCustomers,
          page: 1,
          per_page: newPerPage,
        };
        this.filterCustomers.page = 1;
        this.filterCustomers.per_page = newPerPage;
        this.FetchCustomersData(payload);
      }
    },

    calculateIndex(index) {
      if (this.IsCustomersServerPaginated) {
        return this.CustomersPagination.from - 1 + index;
      } else {
        return this.clientPerPage * (this.clientCurrentPage - 1) + index;
      }
    },

    FilterReport() {
      this.filterCustomers.page = 1;
      this.FetchCustomersData(this.filterCustomers);
    },

    handleExportError() {
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "There was an error exporting customers. Please try again.",
        confirmButtonText: "OK",
      });
    },
  },

  created() {
    this.filterCustomers.per_page = this.clientPerPage;
    this.FetchCustomersData(this.filterCustomers);
    this.FetchCustomers();
    this.FetchRetailOutlets();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title">Customers</h4>
              </div>
              <div class="col-md-3">
                <ExcelExport
                  endpoint="export_customers"
                  filename="customers.xlsx"
                  button-text="Export"
                  button-variant="info"
                  icon-class="fas fa-download"
                  :payload="exportPayload"
                  @export-error="handleExportError"
                />
              </div>
              <div
                v-if="MyUserPerm.add_customers == 1"
                class="col-md-3"
                align="right"
              >
                <b-button v-b-modal.add-customer-modal variant="primary"
                  ><i class="fa fa-plus"></i> Add New</b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="w-100">
                  <label class="mb-0">Search Customers</label>
                  <div class="input-group">
                    <input
                      v-model="filterCustomers.search"
                      type="text"
                      class="form-control"
                      placeholder="Enter name or contact"
                      @keyup.enter="FilterReport()"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-primary"
                        type="button"
                        @click="FilterReport()"
                      >
                        <b-spinner
                          v-if="CustomersFilterStatus"
                          variant="light"
                          small
                          label="Searching"
                        ></b-spinner>
                        <span>Search</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <!-- Table -->
            <div class="table-responsive mb-0 mt-3">
              <div v-if="!IsCustomersServerPaginated">
                <b-table
                  class="datatables"
                  :items="CustomersPaginated || []"
                  :fields="fields"
                  responsive="sm"
                  :per-page="clientPerPage"
                  :current-page="clientCurrentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  show-empty
                  empty-text="No customers found."
                >
                  <template #cell(index)="data">
                    {{ calculateIndex(data.index) + 1 }}
                  </template>
                  <template #cell(name)="data">
                    {{ data.item.name }}
                  </template>
                  <template #cell(phone)="data">
                    {{ data.item.phone }}
                  </template>
                  <template #cell(tin)="data">
                    {{ data.item.tin }}
                  </template>
                  <template #cell(efris)="data">
                    {{ data.item.efris }}
                  </template>
                  <template #cell(debt_limit)="data">
                    {{
                      data.item.debt_limit
                        ? data.item.debt_limit.toLocaleString()
                        : 0
                    }}
                  </template>

                  <template #cell(pricing_category)="data">
                    {{ data.item.pricing_category || "-" }}
                  </template>
                    <template #cell(user)="data">
                      {{ data.item.user }}  
                    </template>
                    <template #cell(addedon)="data">
                      {{ data.item.addedon }}
                    </template>
                  <template #cell(actions)="data">
                    <b-button-group>
                      <b-button
                        v-if="MyUserPerm.edit_customers == 1"
                        size="sm"
                        variant="primary"
                        v-b-modal.edit-customer-modal
                        @click="showEditModal(data)"
                        ><i class="fa fa-edit"></i
                      ></b-button>
                      <b-button
                        size="sm"
                        v-if="MyUserPerm.delete_customers == 1"
                        variant="danger"
                        v-b-modal.delete-product-modal
                        @click="showDeleteModal(data)"
                        ><i class="fa fa-trash"></i
                      ></b-button>
                      <b-button
                        size="sm"
                        variant="success"
                        @click="redirect(data.item.id)"
                        ><i class="fa fa-user"></i>Profile</b-button
                      >
                      <b-button
                        v-if="MyUserPerm.edit_customers == 1"
                        size="sm"
                        variant="info"
                        v-b-modal.merge-customer-modal
                        @click="showMergeModal(data)"
                        ><i class="fa fa-pencil-alt"></i> Merge</b-button
                      >
                    </b-button-group>
                  </template>
                  <template #table-busy>
                    <div class="text-center text-warning my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                </b-table>
              </div>

              <div v-else>
                <table
                  class="table table-striped table-bordered table-responsive nowrap w-100 datatables"
                >
                  <thead>
                    <tr>
                      <th v-for="field in fields" :key="field.key">
                        {{ field.label }}
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="
                      !CustomersFilterStatus &&
                      CustomersPaginated &&
                      CustomersPaginated.length > 0
                    "
                  >
                    <tr
                      v-for="(item, index) in CustomersPaginated"
                      :key="item.id"
                    >
                      <td v-for="field in fields" :key="field.key">
                        <template v-if="field.key === 'index'">
                          {{ calculateIndex(index) + 1 }}
                        </template>
                        <template v-else-if="field.key === 'name'">
                          {{ item.name }}
                        </template>
                        <template v-else-if="field.key === 'phone'">
                          {{ item.phone }}
                        </template>
                        <template v-else-if="field.key === 'tin'">
                          {{ item.tin }}
                        </template>
                        <template v-else-if="field.key === 'efris'">
                          {{ item.efris }}
                        </template>
                        <template v-else-if="field.key === 'debt_limit'">
                          {{ item.debt_limit ? item.debt_limit.toLocaleString() : 0 }}
                        </template>
                        <template v-else-if="field.key === 'pricing_category'">
                          {{ item.pricing_category || "-" }}
                        </template>
                         <template v-else-if="field.key === 'user'">
                          {{ item.user }}
                        </template>
                        <template v-else-if="field.key === 'addedon'">
                          {{ item.addedon }}
                        </template>
                        <template v-else-if="field.key === 'actions'">
                          <b-button-group>
                            <b-button
                              v-if="MyUserPerm.edit_customers == 1"
                              size="sm"
                              variant="primary"
                              v-b-modal.edit-customer-modal
                              @click="showEditModal({ item })"
                              ><i class="fa fa-edit"></i
                            ></b-button>
                            <b-button
                              size="sm"
                              v-if="MyUserPerm.delete_customers == 1"
                              variant="danger"
                              v-b-modal.delete-product-modal
                              @click="showDeleteModal({ item })"
                              ><i class="fa fa-trash"></i
                            ></b-button>
                            <b-button
                              size="sm"
                              variant="success"
                              @click="redirect(item.id)"
                              ><i class="fa fa-user"></i>Profile</b-button
                            >
                            <b-button
                              v-if="MyUserPerm.edit_customers == 1"
                              size="sm"
                              variant="info"
                              v-b-modal.merge-customer-modal
                              @click="showMergeModal({ item })"
                              ><i class="fa fa-pencil-alt"></i> Merge</b-button
                            >
                          </b-button-group>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="CustomersFilterStatus">
                    <tr>
                      <td :colspan="fields.length" class="text-center">
                        <div class="text-warning my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Loading...</strong>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    v-if="
                      !CustomersFilterStatus &&
                      (!CustomersPaginated || CustomersPaginated.length === 0)
                    "
                  >
                    <tr>
                      <td :colspan="fields.length" class="text-center">
                        No customers found.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal starts -->
    <b-modal id="add-customer-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add Customer </template>

      <div class="form-group mb-3">
        <label>Customer Tin</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Tin "
            class="form-control"
            @keyup.enter="submitTin()"
            v-model="data.tindata.tin"
          />
        </div>
        <div class="text-warning" v-if="!tinError && data.efris_status == 0">
          <em>Enter Tin and Press Enter Key to Validate</em>
        </div>
        <div class="text-danger" v-if="tinError">
          <em>{{ tinError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Customer Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Name "
            class="form-control"
            @input="resetError()"
            v-model="data.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Customer Contact <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="number"
            placeholder="Enter Phone Number"
            class="form-control"
            v-model="data.contact"
            @input="resetError()"
          />
        </div>
        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>

      <div class="form-group">
        <label>Select Outlet <span class="text-danger">*</span></label>
        <model-list-select
          :list="RetailOutlets ? RetailOutlets : []"
          v-model="data.category_id"
          option-value="id"
          option-text="name"
          placeholder="Select Outlet"
        >
        </model-list-select>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-customer-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addCustomer('add-customer-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--     edit modal starts-->
    <b-modal id="edit-customer-modal" hide-footer @hidden="resetEdit">
      <template #modal-title> Edit Customer {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <label>Customer Tin</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Tin "
            class="form-control"
            v-model="editdata.tindata.tin"
          />
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Customer Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            @input="resetError()"
            v-model="editdata.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Contact <span class="text-danger">*</span></label>
        <input
          type="number"
          class="form-control"
          @input="resetError()"
          v-model="editdata.contact"
        />
        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-customer-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editCustomer('edit-customer-modal')"
        >
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-product-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title> Delete Customer {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this record? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteCustomer('delete-product-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- map modal starts -->
    <b-modal id="merge-customer-modal" hide-footer @hidden="resetMerge">
      <template #modal-title> Merge Customer {{ mergedata.name }}</template>
      <div class="form-group mb-3">
        <label>Merge into Customer <span class="text-danger">*</span></label>
        <div class="input-group">
          <model-list-select
            :list="Customers ? Customers : []"
            v-model="mergedata.customer"
            option-value="id"
            option-text="name"
            class="mb-3"
            @input="resetError()"
          >
          </model-list-select>
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('merge-customer-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="mergeCustomer('merge-customer-modal')"
        >
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- map modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
.btn-xs {
  padding: 0.25rem 0.4rem;
  font-size: 0.875rem;
  line-height: 0.5;
  border-radius: 0.2rem;
}
</style>
